import {
  CAMPAIGN_DOCUMENT_TYPES,
  CAMPAIGN_INTERNAL_STATUSES,
} from '../../../../../shared/constants'
import { updateCampaignDocument, getCampaignAudience } from './graphQL'
import { generatePDF } from '../../../../DesignManagement/util/generatePDFAPI'
import { updateCampaignsCampaignBuilderData } from '../../../../Country/Page/Pipeline/PipelineView/graphQL'
import {
  hideReduxModal,
  resetReduxModal,
} from '../../../../../Reducers/UI/actions'
import { EXPORT_CSV_TYPES, EXPORT_HEADERS } from './options'
import { escapeCsvString } from '../../../../../shared/csv'
import { downloadStringAsFile } from '../../../../../Utils/Misc'
import { getSelfServeCostData } from '../../../../../Module/graphQL/PathFinder/pathFinderGQL'
import { apiClient } from '../../../../../Module/API/Client'

const handleGetAndUploadFile = async (func, payload) => {
  const fileSelector = document.createElement('input')
  fileSelector.setAttribute('type', 'file')
  if (
    [
      CAMPAIGN_DOCUMENT_TYPES.DIGITAL_PROOF_SIGNED_BY_CLIENT,
      CAMPAIGN_DOCUMENT_TYPES.DIGITAL_PROOF_FROM_PRINTER,
    ].includes(payload.type)
  ) {
    fileSelector.setAttribute('accept', 'application/pdf')
  }
  fileSelector.click()

  fileSelector.addEventListener('change', handleFiles, false)
  async function handleFiles() {
    const file = this.files[0]
    await func({ file, ...payload })
  }
}

const openLinkInNewTab = url => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
}

const openLinkInSameTab = url => {
  const newWindow = (window.location.href = url)
  if (newWindow) newWindow.opener = null
}

const downloadFile = (url, fileName) => {
  fetch(url).then(function(t) {
    return t.blob().then(b => {
      const a = document.createElement('a')
      a.href = URL.createObjectURL(b)
      a.setAttribute('download', fileName)
      a.click()
    })
  })
}

const getDisabledButtonWithLabel = label => ({
  label,
  onClick: () => {},
  disabled: true,
})

const deleteDigitalProofFromPrinterDocument = async ({
  contractId,
  campaignId,
  isCampaignCreatedFromCampaignBuilder,
}) => {
  await updateCampaignDocument({
    id: contractId,
    isActual: false,
  })

  if (isCampaignCreatedFromCampaignBuilder) {
    await updateCampaignsCampaignBuilderData({
      input: {
        campaignId,
        internalStatus: CAMPAIGN_INTERNAL_STATUSES.GENERATING_DIGITAL_PROOF,
      },
    })
  }
}

// const sentDigitalProofToClient = async ({
//   campaignId,
//   isDigitalProofSentToClient,
//   isCampaignCreatedFromCampaignBuilder,
// }) => {
//   await updateCampaign({
//     campaignId,
//     isDigitalProofSentToClient: !isDigitalProofSentToClient,
//   })
//   if (isCampaignCreatedFromCampaignBuilder) {
//     await updateCampaignsCampaignBuilderData({
//       input: {
//         campaignId,
//         internalStatus: !isDigitalProofSentToClient
//           ? CAMPAIGN_INTERNAL_STATUSES.PENDING_DIGITAL_PROOF
//           : CAMPAIGN_INTERNAL_STATUSES.GENERATING_DIGITAL_PROOF,
//       },
//     })
//   }
// }

// const deleteDigitalProofSignedByClient = async ({
//   contractId,
//   campaignId,
//   isCampaignCreatedFromCampaignBuilder,
// }) => {
//   await updateCampaignDocument({
//     id: contractId,
//     isActual: false,
//   })
//
//   if (isCampaignCreatedFromCampaignBuilder) {
//     await updateCampaignsCampaignBuilderData({
//       input: {
//         campaignId,
//         internalStatus: CAMPAIGN_INTERNAL_STATUSES.PENDING_DIGITAL_PROOF,
//       },
//     })
//   }
// }

const downloadFlyerDesign = ({ s3Link, flyerName }) => {
  if (s3Link) {
    downloadFile(s3Link, flyerName)
  } else {
    console.error('s3Link is missing')
  }
}

const onCloseReactModal = () => {
  hideReduxModal()
  resetReduxModal()
}

const formatExportDataByType = ({ data, type }) => {
  if (EXPORT_CSV_TYPES.BASIC_TRACKING === type) {
    return {
      'City': data.cityName,
      'Redemption Codes': data.redemptionCode,
      'Pack Codes': data.packCode,
      'QR URL': data.internalLink,
    }
  }

  if (EXPORT_CSV_TYPES.ADVANCED_TRACKING === type) {
    return {
      'City': data.cityName,
      'Redemption Codes': data.internalCode,
      'QR URL': data.internalLink,
    }
  }

  if (EXPORT_CSV_TYPES.SUMMARY === type) {
    return {
      'Cities': data.cityName,
      'Total Flyers': data.flyers,
      'Total Pack': data.flyersPack,
      'Flyers/Pack': data.flyerPerPack,
      'Redemption Codes': data.redemptionCodesCount,
      'Pack Codes': data.internalCodesCount,
    }
  }

  if (EXPORT_CSV_TYPES.INSERTS_TRACKING === type) {
    return {
      'Client Codes': data.clientCode,
      'Internal Flyer Codes': data.internalFlyerCode,
      'Flyer QR URL': data.shortUrl,
      'Pack QR URL': data.insertsPackScanUrl,
      'Affiliate': data.affiliateName || 'N/A',
    }
  }
}

const onExportData = (data, type, campaignName) => {
  const exportHeaders = EXPORT_HEADERS[type]
  const fileName =
    type === EXPORT_CSV_TYPES.BASIC_TRACKING
      ? 'basicFlyerCodes'
      : EXPORT_CSV_TYPES.ADVANCED_TRACKING === type
      ? 'advancedFlyerCodes'
      : EXPORT_CSV_TYPES.SUMMARY === type
      ? 'summary'
      : EXPORT_CSV_TYPES.INSERTS_TRACKING === type
      ? 'insertsCampaignTracking'
      : null
  let content = exportHeaders.join(',')

  const rows = data
  rows.forEach(item => {
    const rowData = formatExportDataByType({ data: item, type })
    content +=
      '\n' +
      exportHeaders
        .map(headerName => {
          const value = rowData[headerName]
          return typeof value === 'string' ? escapeCsvString(value) : value
        })
        .join(',')
  })
  downloadStringAsFile(content, `${campaignName}-${fileName}.csv`, 'text/csv')
}

const downloadFlyersCodes = async ({
  campaignName,
  clientCodes,
  internalCodes,
  couponType,
}) => {
  if (
    couponType === 'static' ||
    (!couponType && clientCodes.length && internalCodes.length)
  ) {
    const dataBasic = clientCodes.reduce(
      (acc, { city: { name: cityName }, clientCode }) => {
        internalCodes.forEach(
          ({
            city: { name: internalCodesCityName },
            internalCode,
            internalLink,
          }) => {
            if (cityName === internalCodesCityName) {
              acc.push({
                cityName,
                redemptionCode: clientCode,
                packCode: internalCode,
                internalLink,
              })
            }
          },
        )
        return acc
      },
      [],
    )
    onExportData(dataBasic, EXPORT_CSV_TYPES.BASIC_TRACKING, campaignName)
  }
  if (couponType === 'dynamic') {
    const dataBasic = internalCodes.reduce(
      (acc, { city: { name: cityName }, internalCode, internalLink }) => {
        acc.push({ cityName, internalCode, internalLink })

        return acc
      },
      [],
    )

    onExportData(dataBasic, EXPORT_CSV_TYPES.ADVANCED_TRACKING, campaignName)
  }
}

const downloadSummary = async ({
  campaignId,
  campaignName,
  clientCodes,
  internalCodes,
}) => {
  const { campaignDetailedCosts, selectedCities } = await getSelfServeCostData(
    campaignId,
  )

  const city = selectedCities[0]

  const flyerPerPack =
    campaignDetailedCosts.printing.quantity /
    campaignDetailedCosts.distribution.quantity
  const flyersPack = campaignDetailedCosts.distribution.quantity
  const flyers = campaignDetailedCosts.distribution.quantity * flyerPerPack

  const redemptionCodesCount = clientCodes.filter(
    item => item.city.id === city.id,
  ).length
  const internalCodesCount = internalCodes.filter(
    item => item.city.id === city.id,
  ).length

  const data = [
    {
      cityName: city.name,
      flyers,
      flyersPack,
      flyerPerPack,
      redemptionCodesCount,
      internalCodesCount,
    },
    {
      cityName: 'Total',
      flyers,
      flyersPack,
      flyerPerPack,
      redemptionCodesCount,
      internalCodesCount,
    },
  ]

  onExportData(data, EXPORT_CSV_TYPES.SUMMARY, campaignName)
}

const downloadInsertsCampaignTrackingData = async ({
  campaignId,
  campaignName,
}) => {
  try {
    const response = await apiClient.getInsertsCampaignTrackingData(campaignId)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const data = await response.json()

    const campaignCodesData = data.campaignCodesData || []

    const formattedData = campaignCodesData.map(item => ({
      clientCode: item.clientCode || '',
      internalFlyerCode: item.internalFlyerCode || '',
      shortUrl: item.shortUrl || '',
      insertsPackScanUrl: item.insertsPackScanUrl || '',
      affiliateName: item.affiliateName || '',
    }))

    onExportData(formattedData, EXPORT_CSV_TYPES.INSERTS_TRACKING, campaignName)
  } catch (error) {
    console.error('Error downloading campaign tracking data:', error)
  }
}

const checkDesignHasVariables = htmlContent => {
  if (!htmlContent) return false
  return /\{\{.*?\}\}/.test(htmlContent)
}

const replaceVariablesInHtml = (htmlContent, audienceData) => {
  if (!htmlContent || !audienceData) return htmlContent

  let processedHtml = htmlContent

  // Replace standard variables
  const variables = {
    firstName: audienceData.firstName || '',
    lastName: audienceData.lastName || '',
    email: audienceData.email || '',
    address: audienceData.address || '',
    city: audienceData.city || '',
    state: audienceData.state || '',
    zipCode: audienceData.zipCode || '',
  }

  // Replace standard variables
  Object.entries(variables).forEach(([key, value]) => {
    const regex = new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'gi')
    processedHtml = processedHtml.replace(regex, value)
  })

  // Replace custom field variables
  if (audienceData.customFields) {
    Object.entries(audienceData.customFields).forEach(([key, value]) => {
      const regex = new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'gi')
      processedHtml = processedHtml.replace(regex, value || '')
    })
  }

  return processedHtml
}

const downloadAudienceFlyer = async ({
  campaignId,
  campaignName,
  htmlContent,
}) => {
  try {
    // Check if design has variables
    if (!checkDesignHasVariables(htmlContent)) {
      alert(
        'This campaign design does not contain any variables ({{}}). No audience flyer needed.',
      )
      return
    }

    // Fetch audience data
    const audienceData = await getCampaignAudience(campaignId)

    if (!audienceData || audienceData.length === 0) {
      alert('No audience data available for this campaign.')
      return
    }

    // For each audience member, generate a personalized PDF
    for (let i = 0; i < audienceData.length; i++) {
      const audience = audienceData[i]
      const personalizedHtml = replaceVariablesInHtml(htmlContent, audience)

      // Generate PDF
      const pdfBlob = await generatePDF(personalizedHtml)

      // Download the PDF with audience name in filename
      const fileName = `${campaignName}_${audience.firstName ||
        'audience'}_${audience.lastName || i + 1}.pdf`
      const a = document.createElement('a')
      a.href = URL.createObjectURL(pdfBlob)
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)

      // Add delay between downloads to prevent browser blocking
      if (i < audienceData.length - 1) {
        await new Promise(resolve => setTimeout(resolve, 500))
      }
    }
  } catch (error) {
    console.error('Error generating audience flyers:', error)
    alert('Error generating audience flyers. Please try again.')
  }
}

export {
  handleGetAndUploadFile,
  openLinkInNewTab,
  openLinkInSameTab,
  downloadFile,
  getDisabledButtonWithLabel,
  deleteDigitalProofFromPrinterDocument,
  downloadFlyerDesign,
  onCloseReactModal,
  formatExportDataByType,
  downloadFlyersCodes,
  onExportData,
  downloadSummary,
  downloadInsertsCampaignTrackingData,
  checkDesignHasVariables,
  downloadAudienceFlyer,
}
